import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _51b3f64e = () => interopDefault(import('..\\..\\..\\pages\\about.vue' /* webpackChunkName: "pages/about" */))
const _b8b61f12 = () => interopDefault(import('..\\..\\..\\pages\\advantage.vue' /* webpackChunkName: "pages/advantage" */))
const _72159fbd = () => interopDefault(import('..\\..\\..\\pages\\blocProduct.vue' /* webpackChunkName: "pages/blocProduct" */))
const _af95f228 = () => interopDefault(import('..\\..\\..\\pages\\contact.vue' /* webpackChunkName: "pages/contact" */))
const _5264f848 = () => interopDefault(import('..\\..\\..\\pages\\products.vue' /* webpackChunkName: "pages/products" */))
const _3d7142da = () => interopDefault(import('..\\..\\..\\pages\\system.vue' /* webpackChunkName: "pages/system" */))
const _0a95748c = () => interopDefault(import('..\\..\\..\\pages\\detail\\1.vue' /* webpackChunkName: "pages/detail/1" */))
const _023b574e = () => interopDefault(import('..\\..\\..\\pages\\detail\\adv.vue' /* webpackChunkName: "pages/detail/adv" */))
const _c1e4b100 = () => interopDefault(import('..\\..\\..\\pages\\detail\\bm.vue' /* webpackChunkName: "pages/detail/bm" */))
const _baa0927c = () => interopDefault(import('..\\..\\..\\pages\\detail\\dq.vue' /* webpackChunkName: "pages/detail/dq" */))
const _1e28e874 = () => interopDefault(import('..\\..\\..\\pages\\detail\\fpc.vue' /* webpackChunkName: "pages/detail/fpc" */))
const _b394d1fc = () => interopDefault(import('..\\..\\..\\pages\\detail\\fs.vue' /* webpackChunkName: "pages/detail/fs" */))
const _29f4c55a = () => interopDefault(import('..\\..\\..\\pages\\detail\\g3d.vue' /* webpackChunkName: "pages/detail/g3d" */))
const _b00ef1bc = () => interopDefault(import('..\\..\\..\\pages\\detail\\gt.vue' /* webpackChunkName: "pages/detail/gt" */))
const _a6972710 = () => interopDefault(import('..\\..\\..\\pages\\detail\\jm.vue' /* webpackChunkName: "pages/detail/jm" */))
const _50d5a7b6 = () => interopDefault(import('..\\..\\..\\pages\\detail\\jmdzypzz.vue' /* webpackChunkName: "pages/detail/jmdzypzz" */))
const _a5ee0d04 = () => interopDefault(import('..\\..\\..\\pages\\detail\\js.vue' /* webpackChunkName: "pages/detail/js" */))
const _9caea05c = () => interopDefault(import('..\\..\\..\\pages\\detail\\mj.vue' /* webpackChunkName: "pages/detail/mj" */))
const _01353b60 = () => interopDefault(import('..\\..\\..\\pages\\detail\\mjzzzx.vue' /* webpackChunkName: "pages/detail/mjzzzx" */))
const _f82c0604 = () => interopDefault(import('..\\..\\..\\pages\\detail\\qcjczx.vue' /* webpackChunkName: "pages/detail/qcjczx" */))
const _883478e8 = () => interopDefault(import('..\\..\\..\\pages\\detail\\sj.vue' /* webpackChunkName: "pages/detail/sj" */))
const _8736d1d6 = () => interopDefault(import('..\\..\\..\\pages\\detail\\ss.vue' /* webpackChunkName: "pages/detail/ss" */))
const _74636b80 = () => interopDefault(import('..\\..\\..\\pages\\detail\\yd.vue' /* webpackChunkName: "pages/detail/yd" */))
const _7381f370 = () => interopDefault(import('..\\..\\..\\pages\\detail\\yl.vue' /* webpackChunkName: "pages/detail/yl" */))
const _72a07b60 = () => interopDefault(import('..\\..\\..\\pages\\detail\\yt.vue' /* webpackChunkName: "pages/detail/yt" */))
const _6fdfe42e = () => interopDefault(import('..\\..\\..\\pages\\detail\\zn.vue' /* webpackChunkName: "pages/detail/zn" */))
const _124440c4 = () => interopDefault(import('..\\..\\..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _51b3f64e,
    name: "about"
  }, {
    path: "/advantage",
    component: _b8b61f12,
    name: "advantage"
  }, {
    path: "/blocProduct",
    component: _72159fbd,
    name: "blocProduct"
  }, {
    path: "/contact",
    component: _af95f228,
    name: "contact"
  }, {
    path: "/products",
    component: _5264f848,
    name: "products"
  }, {
    path: "/system",
    component: _3d7142da,
    name: "system"
  }, {
    path: "/detail/1",
    component: _0a95748c,
    name: "detail-1"
  }, {
    path: "/detail/adv",
    component: _023b574e,
    name: "detail-adv"
  }, {
    path: "/detail/bm",
    component: _c1e4b100,
    name: "detail-bm"
  }, {
    path: "/detail/dq",
    component: _baa0927c,
    name: "detail-dq"
  }, {
    path: "/detail/fpc",
    component: _1e28e874,
    name: "detail-fpc"
  }, {
    path: "/detail/fs",
    component: _b394d1fc,
    name: "detail-fs"
  }, {
    path: "/detail/g3d",
    component: _29f4c55a,
    name: "detail-g3d"
  }, {
    path: "/detail/gt",
    component: _b00ef1bc,
    name: "detail-gt"
  }, {
    path: "/detail/jm",
    component: _a6972710,
    name: "detail-jm"
  }, {
    path: "/detail/jmdzypzz",
    component: _50d5a7b6,
    name: "detail-jmdzypzz"
  }, {
    path: "/detail/js",
    component: _a5ee0d04,
    name: "detail-js"
  }, {
    path: "/detail/mj",
    component: _9caea05c,
    name: "detail-mj"
  }, {
    path: "/detail/mjzzzx",
    component: _01353b60,
    name: "detail-mjzzzx"
  }, {
    path: "/detail/qcjczx",
    component: _f82c0604,
    name: "detail-qcjczx"
  }, {
    path: "/detail/sj",
    component: _883478e8,
    name: "detail-sj"
  }, {
    path: "/detail/ss",
    component: _8736d1d6,
    name: "detail-ss"
  }, {
    path: "/detail/yd",
    component: _74636b80,
    name: "detail-yd"
  }, {
    path: "/detail/yl",
    component: _7381f370,
    name: "detail-yl"
  }, {
    path: "/detail/yt",
    component: _72a07b60,
    name: "detail-yt"
  }, {
    path: "/detail/zn",
    component: _6fdfe42e,
    name: "detail-zn"
  }, {
    path: "/",
    component: _124440c4,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
